import { doc, collection, runTransaction } from "firebase/firestore";
import { db } from "../firebase/config";

const LOGO_URL = "https://firebasestorage.googleapis.com/v0/b/bodyown-staging.firebasestorage.app/o/logo%2Fbodyown-logo.png?alt=media&token=b3cba539-4cd5-4a19-97a2-f87a908c0bbd";
const SURVEY_URL = "https://bit.ly/bodyown-feedback";

export async function maybeSendFeedbackEmail(uid: string, weekNumber: number) {
  // Guard: this survey email only fires for Week 2
  if (weekNumber !== 2) {
    return;
  }

  try {
    await runTransaction(db, async (transaction) => {
      const userDocRef = doc(db, "users", uid);
      const userSnap = await transaction.get(userDocRef);

      if (!userSnap.exists()) return;

      const userData = userSnap.data();
      if (userData.feedbackEmailSent) return;
      if (!userData.email) return;

      const firstName = userData.firstName?.trim() ? userData.firstName.trim() : "there";
      const mailDocRef = doc(collection(db, "mail"));

      transaction.set(mailDocRef, {
        to: userData.email,
        message: {
          subject: "How was your experience with BodyOwn?",
          html: `<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8" />
  <meta name="viewport" content="width=device-width, initial-scale=1.0" />
  <style>
    body { margin: 0; padding: 0; background-color: #f8f5f2; font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif; -webkit-font-smoothing: antialiased; }
    .wrapper { max-width: 580px; margin: 40px auto; background: #ffffff; border-radius: 16px; box-shadow: 0 4px 12px rgba(29, 21, 14, 0.04); overflow: hidden; border: 1px solid #eeeade; }
    .header { padding: 48px 40px 24px 40px; text-align: center; }
    .header img { height: 42px; width: auto; display: inline-block; border: 0; filter: none; }
    .divider { height: 1px; background-color: #eeeade; margin: 0 40px; }
    .body { padding: 40px; color: #3a3530; font-size: 16px; line-height: 1.75; letter-spacing: -0.01em; }
    .greeting { font-size: 18px; font-weight: 600; color: #1e5e5b; margin-bottom: 20px; }
    .btn-container { margin: 32px 0; text-align: center; }
    .btn { display: inline-block; background-color: #1e5e5b; color: #ffffff !important; padding: 14px 32px; border-radius: 8px; text-decoration: none !important; font-weight: 600; letter-spacing: 0.01em; box-shadow: 0 2px 4px rgba(30, 94, 91, 0.15); }
    .btn:hover { background-color: #143f3d; }
    .body a { color: #1e5e5b; font-weight: 600; text-decoration: underline; text-underline-offset: 4px; }
    .body a:hover { color: #143f3d; }
    .footer { padding: 32px 40px; background-color: #fdfbfa; color: #8a827a; font-size: 12px; text-align: center; border-top: 1px solid #f4f0ea; letter-spacing: 0.02em; }
  </style>
</head>
<body>
  <div class="wrapper">
    <div class="header">
      <img src="${LOGO_URL}" alt="BodyOwn Logo" width="150" height="42" style="height: 42px; width: 150px; display: block; margin: 0 auto; border: 0;" />
    </div>
    <div class="divider"></div>
    <div class="body">
      <p class="greeting">Hi ${firstName},</p>
      <p>We hope you’ve had a chance to explore BodyOwn over the last few days.</p>
      <p>Your feedback is incredibly valuable in helping us improve the platform and ensure it reflects the real needs and experiences of women navigating recovery after birth. We're especially interested in understanding what felt useful, what was missing, and where we can improve the experience.</p>
      <p>When you have a few minutes, we'd love to hear about your experience so far by completing this <a href="${SURVEY_URL}">short survey</a>.</p>
      
      <div class="btn-container">
        <a href="${SURVEY_URL}" class="btn">Start Short Survey</a>
      </div>

      <p style="font-size: 14px; color: #8a827a; text-align: center; margin-top: -12px; margin-bottom: 32px;">
        The survey should take around 3–5 minutes to complete.
      </p>
      
      <p>Thank you again for helping us shape BodyOwn.</p>
      <p style="line-height: 1.5; margin-top: 24px;">Warm wishes,<br /><strong>The BodyOwn Team</strong></p>
    </div>
    <div class="footer">
      &copy; ${new Date().getFullYear()} BodyOwn. All rights reserved.
    </div>
  </div>
</body>
</html>`,
        },
      });

      transaction.update(userDocRef, { feedbackEmailSent: true });
    });
  } catch (err) {
    console.error("FEEDBACK EMAIL TRANSACTION FAILED:", err);
  }
}